<template>
  <div class="pa-6 bid-details font font--p-sm">
    <div class="d-flex mb-2">
      <div class="font--color_light">Дата:</div>
      <div>{{ date }}, {{ time }}</div>
    </div>
    <div class="d-flex mb-2" v-if="details.company_name">
      <div class="font--color_light">Клиент:</div>
      <div>{{ details.company_name }}</div>
    </div>
    <div class="d-flex mb-2" v-if="details.inn">
      <div class="font--color_light">ИНН:</div>
      <div>{{ details.inn }}</div>
    </div>
    <div class="d-flex mb-2">
      <div class="font--color_light">Статус:</div>
      <div><StatusChip :value="details.state" /></div>
    </div>
    <div class="d-flex mb-2">
      <div class="font--color_light">Телефон клиента:</div>
      <div>{{ formatPhone(details.person_phone) }}</div>
    </div>
    <div class="d-flex mb-2">
      <div class="font--color_light">ФИО:</div>
      <div>{{ details.person_fullname }}</div>
    </div>
    <div class="d-flex mb-2">
      <div class="font--color_light">Электронная почта:</div>
      <div>{{ details.person_email }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatPhone } from "@/mixins/formatPhone";
import StatusChip from "@/components/bids/StatusChip";

export default {
  mixins: [formatPhone],
  components: { StatusChip },

  computed: {
    ...mapState("bid", ["statuses", "details"]),

    date() {
      return this.details ? new Date(this.details.dadd).toLocaleDateString() : "";
    },
    time() {
      return this.details ? new Date(this.details.dadd).toLocaleTimeString() : "";
    },
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.bid-details {
  background-color: #f5f5f6;
  & > div > div:first-child {
    flex-basis: 200px;

    @media (max-width: 500px) {
      flex-basis: 90px;
      margin-right: 24px;
      flex-shrink: 0;
    }
  }

  & > div > div:last-child {
    word-wrap: break-word;
    word-break: break-word;
  }
}
</style>
